var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$auth.ready()),expression:"$auth.ready()"}],attrs:{"id":"app"}},[(_vm.$auth.ready())?_c('router-view'):_vm._e(),_c('vue-progress-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }